import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../../../api';

const API_URL = 'http://localhost:3000/api/v1/audit-logs';

export const fetchAuditLogs = createAsyncThunk('auditLogs/fetchAuditLogs', async () => {
    return await apiRequest('/api/v1/audit-logs');
});

const auditLogsSlice = createSlice({
    name: 'auditLogs',
    initialState: {
        items: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAuditLogs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAuditLogs.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(fetchAuditLogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default auditLogsSlice.reducer; 